import React from 'react'
import Manager from '../../public/components/Manager'
import SalaryInfoSettingDetail from './SalaryInfoSettingDetail'
import { doSalaryInfoAction } from '../../business/SalaryInfoAction'
Ext.require('Ext.Toast')

const config = (props) => {
	return {
		tabs: {
			申请中: {
				buttons: [
					{ text: '申请...', handler: ({ showDetail, refreshPage }) => showDetail(props => <SalaryInfoSettingDetail {...props} id={0} />) },
				],
				columns: [
					{ _text: '申请编号', minWidth: 250, search: true, },
					{ _text: '生效月份', field: '_EffectiveMonth', minWidth: 150, },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
					{ _datetime: '申请时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', },
					{ _text: '申请原因', minWidth: 150, flex: 10, search: true },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <SalaryInfoSettingDetail {...props} id={data.id} />)
				}
			},
			驳回申请: {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', minWidth: 250, search: true, },
					{ _text: '生效月份', field: '_EffectiveMonth', minWidth: 150, },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
					{ _datetime: '申请时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', },
					{ _text: '申请原因', minWidth: 150, flex: 10, search: true },
					{ _: 'taskName', field: '_TaskName' }
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <SalaryInfoSettingDetail {...props} id={data.id} taskName={data.taskName} />)
				}
			},
			签核中: {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', minWidth: 250, search: true, },
					{ _text: '生效月份', field: '_EffectiveMonth', minWidth: 150, },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
					{ _datetime: '申请时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', },
					{ _text: '申请原因', minWidth: 150, flex: 10, search: true },
					{ _: '状态名称' },
					// {
					//     _button: '退回申请', icon: 'reply', ui: 'action decline alt', minWidth: 150, handler: ({ showDetail, refreshPage }, data) => {
					//         doSalaryInfoAction(props.dispatch, '退回申请', { id: data.id, action: `${data.状态名称}.退回申请`, onSave: refreshPage, showDetail: showDetail })
					//     }
					// },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <SalaryInfoSettingDetail {...props} id={data.id} readOnly={true} />)
				}
			},
			已完成: {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', minWidth: 250, search: true, },
					{ _text: '生效月份', field: '_EffectiveMonth', minWidth: 150, },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
					{ _datetime: '申请时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', },
					{ _text: '申请原因', minWidth: 150, flex: 10, search: true },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <SalaryInfoSettingDetail {...props} id={data.id} />)
				}
			}
		}
	}
}

export default props => <Manager {...props} config={config} />